import { FormattedHTMLMessage, FormattedMessage } from "react-intl"
import EdDonDropdown from "./EdDonDropdown"
import FoodPansDropdown from "./FoodPansDropdown"
import calculateDimensions from "./calculateDimensions"
import MeasurementRadioButtons from "./MeasurementRadioButtons"
import MeasurementInputs from "./MeasurementInputs"

class Calculator extends React.Component {
  state = {
    measurement: "imperial",
    transporterType: "bags",
    containerType: "container",
    foodPanDescription: "",
    containerDescription: "Dimensions",
    selectedContainerId: "Dimensions",
    width: "",
    length: "",
    height: "",
    boxCount: "",
    containers: this.props.containers,
    foodPans: this.props.food_pans,
    selectedFoodPanSize: "",
    selectedDepth: "",
    depthList: [],
  }

  handleFormSubmit = () => {
    const dimensions = {
      width: this.state.width,
      height: this.state.height,
      length: this.state.length,
      count: this.state.boxCount,
      measurement: this.state.measurement,
      transporterType: this.state.transporterType,
      containerType: this.state.containerType,
      foodPanDescription: this.state.foodPanDescription,
      containerDescription: this.state.containerDescription,
    }
    this.props.setContainerState(dimensions)
  }

  handleGoBoxSubmit = (event) => {
    event.preventDefault()
    if (this.form.checkValidity()) {
      this.setState({ transporterType: "boxes" }, this.handleFormSubmit)
    } else {
      this.displayErrorMessagesFor(this.form)
      return false
    }
  }

  handleGoBagSubmit = (event) => {
    if (this.form.checkValidity()) {
      event.preventDefault()
      this.setState({ transporterType: "bags" }, this.handleFormSubmit)
    } else {
      this.displayErrorMessagesFor(this.form)
      return false
    }
  }

  setSelectedContainerId = (event) => {
    this.setState(
      {
        selectedDepth: "",
        selectedFoodPanSize: "",
        containerType: "container",
        foodPanDescription: "",
        containerDescription:
          event.target.options[event.target.selectedIndex].text,
        selectedContainerId: event.target.value,
      },
      this.updateDimensions
    )
  }

  setSelectedFoodPanSize = (event) => {
    this.setState(
      {
        selectedContainerId: "",
        selectedDepth: "",
        containerType: "foodPan",
        containerDescription: "",
        foodPanDescription: event.target.value,
        selectedFoodPanSize: event.target.value,
      },
      this.updateDepthList
    )
  }

  updateDepthList = () => {
    const list = this.state.foodPans.filter(
      (pan) => pan.size == this.state.selectedFoodPanSize.split(" ")[0]
    )

    this.setState({
      depthList: [...new Set(list.map((pan) => pan.height))].sort((a, b) => {
        return a - b
      }),
    })
  }

  setSelectedDepth = (event) => {
    this.setState(
      {
        selectedContainerId: "",
        containerType: "foodPan",
        selectedDepth: event.target.value,
      },
      this.updateDimensions
    )
  }

  toggleMeasurement = () => {
    this.setState(
      {
        measurement: this.newMeasurement(),
      },
      this.updateDimensions
    )
  }

  updateDimensions = () => {
    this.setState((currentState) => calculateDimensions(currentState))
  }

  newMeasurement = () => {
    return this.state.measurement === "imperial" ? "metric" : "imperial"
  }

  handleInputFocus = (event) => {
    event.target.placeholder = ""
    this.setState({ selectedContainerId: "", [event.target.name]: "" })
  }

  displayErrorMessagesFor = (form) => {
    const elements = form.querySelectorAll("input[type=number]")

    for (let i = 0; i < elements.length; i++) {
      const elem = elements[i]
      const errorLabel = elem.parentNode.getElementsByClassName(
        ".invalid-feedback"
      )[0]

      if (errorLabel) {
        if (!elem.validity.valid) {
          errorLabel.textContent = elem.validationMessage
        } else {
          errorLabel.textContent = ""
        }
      }
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  render() {
    const { containers } = this.props

    const radioStyle = {
      opacity: "100",
      height: "15px",
      marginLeft: "20px",
    }

    const errorStyle = {
      color: "red",
      paddingTop: "5px",
    }

    // let transporterType = this.state.transporterType === "bags" ? "GoBag" : "GoBox"

    return (
      <form ref={(form) => (this.form = form)}>
        <div className="form-group">
          <div className="gobag-option1"></div>
          <EdDonDropdown
            setSelectedContainerId={this.setSelectedContainerId}
            containers={containers}
          />
          <br />
        </div>
        <div className="form-group">
          {!window.location.pathname.includes("don") && (
            <div className="gobag-option2"></div>
          )}
          <FoodPansDropdown
            setSelectedFoodPanSize={this.setSelectedFoodPanSize}
            selectedFoodPanSize={this.state.selectedFoodPanSize}
            containers={this.state.foodPans}
            depthList={this.state.depthList}
            setSelectedDepth={this.setSelectedDepth}
            selectedDepth={this.state.selectedDepth}
          />
        </div>
        <div className="cleaner"></div>
        <br />
        {window.location.pathname.includes("don") ? (
          <div className="gobag-option2-ed-don"></div>
        ) : (
          <div className="gobag-option3"></div>
        )}

        <MeasurementRadioButtons
          style={radioStyle}
          toggleMeasurement={this.toggleMeasurement}
        />
        <MeasurementInputs
          handleChange={this.handleChange}
          handleInputFocus={this.handleInputFocus}
          errorStyle={errorStyle}
          width={this.state.width}
          height={this.state.height}
          length={this.state.length}
        />
        <div className="form-row">
          <label>
            <FormattedMessage id="togo.optional_hint" />

            <input
              name="boxCount"
              value={this.state.boxCount}
              onChange={this.handleChange}
              type="number"
              pattern="\d+"
              min="1"
            />
            <div className=".invalid-feedback" style={errorStyle} />
          </label>
        </div>
        <div className="btn-centered">
          <div className="gobag-pick-one"></div>
          <button
            type="submit"
            onClick={this.handleGoBagSubmit}
            className="btn-gobag"
          >
            <FormattedMessage id="togo.actions.find_gobag" />
          </button>
          <button
            type="submit"
            onClick={this.handleGoBoxSubmit}
            className="btn-gobox"
          >
            <FormattedMessage id="togo.actions.find_gobox" />
          </button>
        </div>
        <p>
          <em>
            <FormattedHTMLMessage id="togo.note" />
          </em>
        </p>
      </form>
    )
  }
}

export default Calculator
